// extracted by mini-css-extract-plugin
export default {"disabled":"s_ZOG"};